import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the OpenNowPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'openNow',
})
export class OpenNowPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(placeData: any) {
    return (
      placeData && placeData.opening_hours && placeData.opening_hours.isOpen()
    );
  }
}



// WEBPACK FOOTER //
// ./src/pipes/open-now/open-now.ts